/** Follow-up questions under the last answer, about the brotherhood it was about. */
export function FollowUps({
  name,
  questions,
  onPick,
}: {
  name: string;
  questions: string[];
  onPick: (q: string) => void;
}) {
  if (questions.length === 0) return null;
  return (
    <ul className="animate-rise flex flex-wrap gap-2" aria-label={`Más preguntas sobre ${name}`}>
      {questions.map((q) => (
        <li key={q}>
          <button
            type="button"
            onClick={() => onPick(q)}
            className="min-h-11 rounded-full border border-purple/20 bg-paper px-4 py-2 text-left text-[0.95rem] leading-snug text-purple transition duration-150 hover:border-purple/45 hover:bg-white active:scale-[0.98] active:bg-cream-200/60 dark:border-cream/15 dark:bg-night-800 dark:text-gold-300 dark:hover:border-gold/50 dark:hover:bg-night-700"
          >
            {q}
          </button>
        </li>
      ))}
    </ul>
  );
}
